import { useState } from "react";
import Wings from "../images/wings_only.png";
import { Button } from "@mui/material";
import axios from "axios";
import { Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreatePassword() {
  const url = process.env.REACT_APP_URL;
  const navigate = useNavigate();
  const [oneTimePassword, setOneTimePassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
    }, duration);
  };

  const handleValidation = async () => {
    setDisable(true);
    if (oneTimePassword === "") {
      handleAlert("Please enter one time password", "warning");
    } else if (newPassword === "") {
      handleAlert("Please enter new password", "warning");
    } else {
      handleCreatePassword();
    }
  };

  const handleCreatePassword = async () => {
    let reqBody = {
      oldPassword: oneTimePassword,
      newPassword: newPassword.trim(),
      userId: localStorage.getItem("userId"),
    };

    await axios
      .post(`${url}/login/create-password`, reqBody)
      .then((res) => {
        navigate("/");
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - please try again", 'error');
      });
  };

  const enter = (e) => {
    if (e.keyCode === 13) {
      handleValidation();
    }
  };

  return (
    <main className="create-password">
      <section className="middle-section">
        <img src={Wings} />
        <form>
          <h3>Please create your new password</h3>
          <div className="form-single">
            <label>Enter one time password</label>
            <input
              type="text"
              placeholder="Enter one time password"
              value={oneTimePassword}
              onChange={(e) => setOneTimePassword(e.target.value)}
            />
          </div>
          <div className="form-single">
            <label>Enter your new password</label>
            <input
              type="password"
              placeholder="Enter your new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              onKeyDown={(e) => enter(e)}
            ></input>
          </div>
          <section className="alert-section">
            {alert ? <Alert severity={severity}>{message}</Alert> : null}
          </section>
          <Button
            variant="contained"
            color="success"
            disabled={disable}
            onClick={handleValidation}
          >
            Submit
          </Button>
        </form>
      </section>
    </main>
  );
}
